const FRONTEND_TOGGLES_STORAGE_KEY = 'axo.frontend.toggle';

export const saveFrontendToggles = <
  T extends Record<string, unknown>,
  K extends keyof T
>(
  data: T,
  frontendToggles: readonly K[]
) => {
  const storage = sessionStorage.getItem(FRONTEND_TOGGLES_STORAGE_KEY);
  const store = JSON.parse(storage || '{}');

  for (const key of frontendToggles) {
    if (key in data) {
      if (store[key] !== data[key]) {
        Object.assign(store, {
          [key]: data[key],
        });
      }
    }
  }

  sessionStorage.setItem(FRONTEND_TOGGLES_STORAGE_KEY, JSON.stringify(store));

  return {};
};

export const reloadFrontendToggles = (data: Record<string, unknown>) => {
  const storage = sessionStorage.getItem(FRONTEND_TOGGLES_STORAGE_KEY);

  const result: Record<string, 'Yes' | 'No' | undefined> = JSON.parse(
    storage || '{}'
  );

  if (
    Object.keys(data).filter((key) => key.match(/CoApp|CoPerson|CoCustomer/))
      .length > 0
  ) {
    Object.assign(result, {
      'Frontend/AddCoApplicant': 'Yes',
    });
  }

  // coApplicant=true
  if (typeof window !== 'undefined') {
    const coApplicant = new URLSearchParams(window.location.search).get(
      'coApplicant'
    );
    if (coApplicant === 'true') {
      Object.assign(result, {
        'Frontend/AddCoApplicant': true,
      });
    }
  }

  return result;
};
